export const GAMIFICATION_SAVE_SCOPE = 'gamificationSave';
